import { render, staticRenderFns } from "./EMImpostazioni.vue?vue&type=template&id=c1a1c582&scoped=true&"
import script from "./EMImpostazioni.vue?vue&type=script&lang=js&"
export * from "./EMImpostazioni.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c1a1c582",
  null
  
)

export default component.exports